import AdTypeView from "../views/AdTypeView.vue";
import AddOnsView from "../views/AddOnsView.vue";
import BuilderView from "../views/BuilderView.vue";
import CartView from "../views/CartView.vue";
import BillingView from "../views/BillingView.vue";
import PaymentView from "../views/PaymentView.vue";
import ConfirmationView from "../views/ConfirmationView.vue";
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
    {
        path: "/",
        name: "ad-type",
        component: AdTypeView,
    },
    {
        path: "/add-ons",
        name: "add-ons",
        component: AddOnsView,
        beforeEnter: (to, from, next) => {
            if (!localStorage.getItem("people_order_item")) {
                return next("/");
            }

            if (JSON.parse(localStorage.getItem("people_order_item")).total == 0) {
                return next("/");
            }

            return next();
        },
    },
    {
        path: "/builder",
        name: "builder",
        component: BuilderView,
        beforeEnter: (to, from, next) => {
            if (!localStorage.getItem("people_order_item")) {
                return next("/");
            }

            if (JSON.parse(localStorage.getItem("people_order_item")).total == 0) {
                return next("/");
            }

            if (!JSON.parse(localStorage.getItem("people_order_item")).add_ons) {
                return next("/");
            }

            return next();
        },
    },
    {
        path: "/cart",
        name: "cart",
        component: CartView,
        beforeEnter: (to, from, next) => {
            if (to?.query?.token) {
                localStorage.setItem("people_token", to.query.token);

                to.query = {};

                return next("/cart");
            } else {
            }

            return next();
        },
    },
    {
        path: "/billing",
        name: "billing",
        component: BillingView,
        beforeEnter: (to, from, next) => {
            if (!localStorage.getItem("people_token") && !localStorage.getItem("people_order")) {
                return next("/cart");
            }
            return next();
        },
    },
    {
        path: "/payment",
        name: "payment",
        component: PaymentView,
        beforeEnter: (to, from, next) => {
            if (
                !localStorage.getItem("people_token") &&
                !localStorage.getItem("people_order") &&
                !sessionStorage.getItem("people_billing")
            ) {
                return next("/billing");
            }
            return next();
        },
    },
    {
        path: "/confirmation",
        name: "confirmation",
        component: ConfirmationView,
        beforeEnter: (to, from, next) => {
            if (!localStorage.getItem("people_transaction_id")) {
                return next("/payment");
            }
            return next();
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
